var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.089,
    height: 71.392,
    viewBox: "0 0 68.089 71.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-people",
    "data-name": "Icon ionic-ios-people",
    transform: "translate(-23.011 -7.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M65.1,62.675c-2.74-.979-7.217-1.028-9.2-1.786-1.37-.538-3.548-1.125-4.257-1.982s-.71-6.973-.71-6.973a11.264,11.264,0,0,0,2.422-3.425,38.067,38.067,0,0,0,1.174-6.728s1.615.685,2.251-2.544c.538-2.789,1.566-4.257,1.3-6.312-.294-2.055-1.419-1.566-1.419-1.566s1.419-2.08,1.419-9.15c0-7.291-5.5-14.459-15.805-14.459-10.276,0-15.83,7.193-15.83,14.459,0,7.071,1.395,9.15,1.395,9.15s-1.15-.489-1.419,1.566c-.294,2.055.734,3.523,1.3,6.312.636,3.254,2.251,2.544,2.251,2.544a38.435,38.435,0,0,0,1.174,6.728,11.264,11.264,0,0,0,2.422,3.425s0,6.117-.71,6.973S29.966,60.35,28.6,60.864c-1.957.758-6.435.856-9.2,1.835A17.267,17.267,0,0,0,8.191,79.14H76.28A17.233,17.233,0,0,0,65.1,62.675Z",
    transform: "translate(14.82)",
    fill: "#db1c2b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.d9ac5ac0.svg";
export { ForwardRef as ReactComponent };